<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <Page>
        <Container>
            <CellGroup border>
                <Cell
                    label="证书领取方式"
                    extra="到校自取"/>
            </CellGroup>

            <div class="pa-a tc-g6 dp-fx fx-col fx-jc-fs fx-ai-sb">
                <div>客服电话：{{$globalVar.invoiceContactNumber}}</div>
                <div>学校地址：{{$globalVar.schoolAddress}}</div>
            </div>

            <MaterialsList
                v-if="orderInvoiceOffline.id"
                ref="materialsList"
                class="ma-t"
                :value-type="6"
                :value-id="orderInvoiceOffline.id"
                :extra-query="materialsExtraQuery"
            ></MaterialsList>

        </Container>
        <PageBar
            v-if="invoiceOfflineStatus===10"
            position="bottom">
            <XButton
                class="item"
                theme="second"
                @click="()=>{onCancel()}"
            >重选开票方式</XButton>
            <XButton
                class="item"
                theme="success"
                @click="()=>{onSubmit()}"
            >确认已领取</XButton>
        </PageBar>
    </Page>
</template>

<script>
import { pageMixin } from 'mixins';
import { Device } from 'utils';
import MaterialsList from 'pages/Materials/_MaterialsList.vue';

export default {
    name: 'DetailPage',
    components: { MaterialsList },
    mixins: [pageMixin],
    data() {
        return {
            orderId: this.$route.query.orderId,
            detail: {},
        };
    },
    computed: {
        orderInvoiceOffline() {
            return this.detail.orderInvoiceOffline || {};
        },
        invoiceOfflineStatus() {
            return this.orderInvoiceOffline.invoiceOfflineStatus || 0;
        },
        materialsExtraQuery() {
            const { invoiceOfflineStatus } = this;
            return {
                invoiceOfflineStatus,
                orderInvoiceOfflineId: this.orderInvoiceOffline.id,
                orderId: this.orderId,
            };
        },
    },
    watch: {
        shipMethodList: {
            handler(val) {
                if (!val || !val.length) return;
                const { certificateReceiveBatch } = this;
                this.formModel.shipMethod = `${certificateReceiveBatch.shipMethod || ''}` || `${val[0].id || ''}`;
            },
            immediate: true,
        },
    },
    methods: {
        async getDetail() {
            const { orderId } = this;
            if (!orderId) return;
            const { data } = await this.$api.Member.Ex.OrderInvoiceOffline.detail({ orderId });
            this.detail = data;
        },
        async onCancel() {
            await this.$messageBox.confirm('是否确认重选开票方式!');
            await this.$api.Member.Ex.OrderInvoiceOffline.cancel({ id: this.orderInvoiceOffline.id });
            this.$router.back();
        },
        async onSubmit() {
            await this.$messageBox.confirm('是否确认操作!');
            const { msg } = await this.$api.Member.Ex.OrderInvoiceOffline.confirm({ id: this.orderInvoiceOffline.id });
            this.$router.replace(`/order/detail/${this.orderId}`);
            if (msg) this.$messageBox.tips(msg);
        },
        onDownIssueCertificate() {
            if (Device.weixin && !Device.windowsWechat) {
                this.$messageBox.alert('手机端浏览器暂不支持操作，请在电脑浏览器操作!');
                return;
            }
            this.$http.href('/member/mb/enterpriseExcel/exportCertificateReceiveBatchDetailList', {
                certificateReceiveBatchId: this.certificateReceiveId,
            });
        },
    },
    activated() {
        this.getDetail();
    },
};
</script>

<style lang="scss">
</style>
